import SBNiceDate from '@components/utils/SBNiceDate'
import { UserDeviceAnonymousId, UserDeviceDetails } from '@models/PostHog'
import { fetchDeviceDetailsForUser } from '@services/UserService'
import { Button, Card, Divider, Space, Typography } from 'antd'
import { useState } from 'react'
import InnerUserDeviceDetails from './InnerUserDeviceDetails'

const { Text } = Typography

interface Props {
  trashed?: boolean
  userId: number
  device: UserDeviceAnonymousId
}

const InnerUserDeviceAnonymousId = ({
  userId,
  device,
  trashed = false,
}: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [deviceDetails, setDeviceDetails] = useState<UserDeviceDetails>()
  const [error, setError] = useState<string | null>(null)

  const fetchDetails = () => {
    setIsLoading(true)
    setError(null)
    fetchDeviceDetailsForUser(userId, device.id)
      .then((details) => {
        setDeviceDetails(details)
      })
      .catch((_) => {
        setError('Failed to fetch device details')
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Card
      style={{ opacity: trashed ? 0.5 : 1, margin: '0 auto' }}
      styles={{ body: { padding: 24 } }}
    >
      <Space orientation="vertical" size={0} style={{ width: '100%' }}>
        <Space
          orientation="horizontal"
          size={8}
          align="center"
          style={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Text type="secondary">Pléthore mobile app</Text>
          <Space>
            <Text>Unique ID:</Text>
            <Text strong copyable={{ text: device.id?.toString() }}>
              {device.id}
            </Text>
          </Space>
        </Space>
        <Divider style={{ margin: '12px 0' }} />
        <Space
          orientation="horizontal"
          className="space-between"
          size={2}
          style={{ width: '100%' }}
        >
          <Text>
            Created:{' '}
            <SBNiceDate date={device.createdAt} textProps={{ strong: true }} />
          </Text>
          {device.deletedAt && (
            <Text>
              Deleted:{' '}
              <SBNiceDate
                date={device.deletedAt}
                textProps={{ strong: true }}
              />
            </Text>
          )}
        </Space>
        {!trashed && !deviceDetails && (
          <>
            <Button
              type="primary"
              block
              onClick={fetchDetails}
              loading={isLoading}
              style={{ marginTop: 12 }}
            >
              Get details
            </Button>
            {error && (
              <Text type="danger" style={{ marginTop: 8, display: 'block' }}>
                {error}
              </Text>
            )}
          </>
        )}
        {!trashed && deviceDetails && (
          <Card style={{ marginTop: 16, borderRadius: 8 }}>
            <InnerUserDeviceDetails device={deviceDetails} />
          </Card>
        )}
      </Space>
    </Card>
  )
}

export { InnerUserDeviceAnonymousId }
